<template>
    <ion-tabs ref="specialsTabs">

        <div class="scroll-y with-tabs custom-scrollbar">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>

        <!-- fix for active tabs -->
        <!--<ion-tab tab="tab-list"></ion-tab>-->
        <!--<ion-tab tab="tab-detail"></ion-tab>-->
        <!--<ion-tab tab="tab-summary"></ion-tab>-->

        <!-- tab nav bar -->
        <ion-tab-bar slot="bottom">
            <!--<ion-tab-button tab="tab-list" mode="md" href="undefined">-->
                <router-link :to="{ name: 'SpecialsIndex' }" class="tab-router-link exact">
                    <svg class="tab-icon"><use xlink:href="#icon-list-challenges"></use></svg>
                    <ion-label class="tab-text">Lista zadań</ion-label>
                </router-link>
            <!--</ion-tab-button>-->
            <!--<ion-tab-button tab="tab-detail" mode="md" href="undefined">-->
                <router-link :to="{ name: 'SpecialsSingle' }" class="tab-router-link exact">
                    <svg class="tab-icon"><use xlink:href="#icon-pathway"></use></svg>
                    <ion-label class="tab-text">Opis zadania</ion-label>
                </router-link>
            <!--</ion-tab-button>-->
            <!--<ion-tab-button tab="tab-summary" mode="md" href="undefined">-->
                <router-link :to="{ name: 'SpecialsSummary' }" class="tab-router-link exact">
                    <svg class="tab-icon"><use xlink:href="#icon-shield"></use></svg>
                    <ion-label class="tab-text">Realizacja zadania</ion-label>
                </router-link>
            <!--</ion-tab-button>-->
        </ion-tab-bar>

    </ion-tabs>
</template>

<script>

    export default {
        name: 'ChallangesIndex',
        props: {
            slug : {
                type: [String, Number],
                requred: true
            }
        },
        mounted(){ /* **** */ },

    }

</script>

<style lang="scss" scoped>
    //fix for hidden tabs container
    /*ion-tab {
         display: none !important;
     }

    ion-tab-button {
        pointer-events: none !important;
    }*/

</style>